import httpVerify from "./axios/http-verify-userId";
import {
  clearAccessToken,
  getAccessToken,
  withBrowserAuth,
} from "./browser-session";

class VerifyUserId {
  constructor() {
    this.fetchUserIdData = "/userId";
  }

  fetchUserId(userId, options = {}) {
    const url = `${this.fetchUserIdData}/${encodeURIComponent(userId)}`;
    if (!getAccessToken()) return httpVerify.get(url, options);
    return httpVerify.get(url, withBrowserAuth(options)).catch((error) => {
      if (
        [401, 403].includes(error?.response?.status) &&
        !options.signal?.aborted
      ) {
        // The approved public ID lookup can issue a fresh session once when a
        // previous tab session expired or belongs to a different URL user.
        clearAccessToken();
        return httpVerify.get(url, options);
      }
      throw error;
    });
  }
}
export default new VerifyUserId();
